import { ContainerPadding, Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { Alert } from '@volkswagen-onehub/icons-core';
import React, { useEffect } from 'react';
import { FORM_MESSAGE } from '../../constants/form-constants';
import { COLOR_TOKEN } from '../../constants/styles-constants';
import { useApp } from '../../contexts/app-context';
import { scrollToTop } from '../../helpers/form-helpers';
import { Section } from './section';

interface Props {
	children?: React.ReactNode;
	color?: string;
	align?: string;
	log?: string;
}

const ErrorContent = (props: Props) => {
	const { children, color, align, log } = props;
	const { errorLog } = useApp();
	const params = new URLSearchParams(window.location.search);
	const showErrorLog = params.has('log') || params.has('debug');

	const textAlign = align === 'left' ? TextAlignment.left : TextAlignment.center;

	return (
		<>
			<div style={{ marginRight: '8px', color: color ? color : COLOR_TOKEN.displayTag.error.background }}>
				<Alert variant="large" />
			</div>
			<Text appearance={TokenTextAppearance.copy100} textAlign={textAlign}>
				<div style={{ color: color ? color : COLOR_TOKEN.displayTag.error.background }}>
					{children ? children : FORM_MESSAGE.GENERIC_ERROR}
				</div>
				{showErrorLog && (
					<>
						<div style={{ color: color ? color : COLOR_TOKEN.displayTag.error.background }}>
							<b>{log}</b>
						</div>
						<div style={{ color: color ? color : COLOR_TOKEN.displayTag.error.background }}>
							<b>{errorLog}</b>
						</div>
					</>
				)}
			</Text>
		</>
	);
};
interface ScreenProps {
	children?: React.ReactNode;
	color?: string;
}

export const ErrorScreen = (props: ScreenProps) => {
	const { color } = props;

	useEffect(() => {
		scrollToTop();
	}, []);

	return (
		<div
			style={{
				color: color ? color : COLOR_TOKEN.displayTag.error.background,
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				padding: '0 20px',
				height: 'calc(100vh - 80px - var(--size-dynamic0270) - var(--size-dynamic0100))',
			}}
		>
			<ErrorContent {...props} />
		</div>
	);
};

interface SectionProps {
	children: React.ReactNode;
	color?: string;
	align?: string;
	height?: string;
	paddingTop?: ContainerPadding;
	paddingBottom?: ContainerPadding;
	log?: string;
}

export const ErrorSection = (props: SectionProps) => {
	const { color, align, height, paddingTop, paddingBottom } = props;
	return (
		<Section paddingTop={paddingTop} paddingBottom={paddingBottom}>
			<div
				style={{
					color: color ? color : COLOR_TOKEN.displayTag.error.background,
					display: 'flex',
					flexDirection: 'row',
					justifyContent: align ? align : 'center',
					alignItems: 'center',
					height: height ? height : 'auto',
				}}
			>
				<ErrorContent {...props} />
			</div>
		</Section>
	);
};

export const ErrorIcon = () => <Alert />;
